<div class="max-w-md mx-auto space-y-4">
            @if (messageType === "ERROR") {
                <p-message severity="error" icon="pi pi-times-circle">{{message}}</p-message>
            }@if (messageType === "WARN") {
                <p-message severity="warn" icon="pi pi-exclamation-triangle">{{message}}</p-message>
            }
</div>